import { TextArea } from "shared/components/forms/TextArea";

export const LongTextPreview = ({
  value,
  onChange
}: {
  value: string;
  onChange: (value: string) => void;
}) => {
  return (
    <TextArea
      id="preview-long-text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Type your answer here"
      legacyErrorMargins={false}
      rows={4}
    />
  );
};
